/*
 * server-error-interceptor.ts
 * utms-admin-dashboard
 *
 * Created by Tetiana Makovii on 19.04.2022
 * Copyright © 2026 Sonova AG. All rights reserved.
 */

import { Injectable, NgZone } from '@angular/core';
import {
  HttpEvent,
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorReportingService } from './error-reporting.service';

@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {
  constructor(
    private zone: NgZone,
    public snackBar: MatSnackBar,
    private errorReportingService: ErrorReportingService,
  ) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      retry(1),
      catchError((error: HttpErrorResponse) => {
        let errorMessage = '';
        let l_errorArray: string[] = [];
        if (error.error == typeof String)
          l_errorArray = error.error.split('\n');
        l_errorArray = l_errorArray.filter((val) =>
          val.toLowerCase().startsWith('message'),
        );
        let l_errorMessage = '';
        if (l_errorArray.length > 0) l_errorMessage = l_errorArray[0];
        if (error.error instanceof ErrorEvent) {
          // client-side error
          errorMessage = `Error: ${error.error.message}\n`;
        } else {
          // server-side error
          errorMessage = `Error Status: ${error.status} | \n${l_errorMessage} | \nHttp message: ${error.message}\n`;
        }

        this.zone.run(() => {
          if (errorMessage != undefined)
            this.snackBar.open(errorMessage, 'X', { panelClass: 'auto-width' });
        });

        console.error(errorMessage);
        this.errorReportingService.captureException(error);

        return throwError(() => errorMessage);
      }),
    );
  }
}
